import type { EmailOptions, SmsOptions } from '@brighterly/lib-core-types/support/interfaces'

const normalizeToArray = (v?: string | string[]): string[] => {
  if (!v) return []
  return Array.isArray(v) ? v : [v]
}

export const normalizePhoneForWhatsApp = (raw: string): string => {
  return (raw || '').replace(/\D+/g, '')
}

export const buildMailtoUrl = ({ to, subject, body, cc, bcc }: EmailOptions): string => {
  const params: string[] = []
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`)
  if (body) params.push(`body=${encodeURIComponent(body)}`)

  const ccArr = normalizeToArray(cc)
  const bccArr = normalizeToArray(bcc)
  if (ccArr.length) params.push(`cc=${encodeURIComponent(ccArr.join(','))}`)
  if (bccArr.length) params.push(`bcc=${encodeURIComponent(bccArr.join(','))}`)

  const toList = normalizeToArray(to).join(',')
  const query = params.length ? `?${params.join('&')}` : ''
  return `mailto:${toList}${query}`
}

export const buildSmsUrl = ({ phone, body }: SmsOptions): string => {
  const target = phone.startsWith('+')
    ? phone
    : `+${phone.replace(/\D+/g, '')}`

  const query = body
    ? `?body=${encodeURIComponent(body)}`
    : ''

  return `sms:${target}${query}`
}
